import { render, staticRenderFns } from "./switchTMG.vue?vue&type=template&id=c733477e&scoped=true&"
import script from "./switchTMG.vue?vue&type=script&lang=js&"
export * from "./switchTMG.vue?vue&type=script&lang=js&"
import style0 from "./switchTMG.vue?vue&type=style&index=0&id=c733477e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c733477e",
  null
  
)

export default component.exports